import { Typography } from "@mui/material";
import { IDashboardContract } from "../../../../api/hooks/useContracts";
import { NullableProps } from "@synota-io/synota-shared-ui";
import { delaySecondsToHours } from "../../../../utils/date";

export const SettlementDelayCell = ({
  row,
}: {
  row: {
    delay_in_seconds?: number;
    advanced_settlement_delay?: NullableProps<
      Partial<IDashboardContract["advanced_settlement_delay"]>
    >;
  };
}) => {
  if (
    !row.advanced_settlement_delay ||
    (!row.advanced_settlement_delay.days_delayed && !row.advanced_settlement_delay.time_of_day)
  ) {
    if (row.delay_in_seconds) {
      return delaySecondsToHours(row.delay_in_seconds);
    }

    return "N/A";
  }

  const daysDelayed = row.advanced_settlement_delay.days_delayed || 0;

  const timeElement = `${row.advanced_settlement_delay.time_of_day} ${row.advanced_settlement_delay.time_zone}`;
  const arrearElement = `${daysDelayed} days after`;

  const content = daysDelayed > 0 ? `${timeElement}, ${arrearElement}` : timeElement;

  return (
    <Typography
      title={daysDelayed > 0 ? arrearElement : undefined}
      variant="inherit"
      fontWeight="bold"
      textOverflow="ellipsis"
      sx={{ wordBreak: "keep-all", whiteSpace: "nowrap" }}
      overflow="hidden"
    >
      {content}
    </Typography>
  );
};
